import api from '@/api';

// 用户模块状态
const state = {
    // 访问令牌
    token: '',
    // 支付令牌
    payToken: '',
    // 是否开通授信
    isOpenCredit: true,
    // 用户名字
    name: '',
    // 用户头像
    avatar: '',
    // 服务商信息
    franchisee: null,
    //用户信息
    userInfo: '',
    //钱包信息
    walletInfo: null,
    merchantPubId: null
};

// 用户模块mutations
const mutations = {
    /**
     * 设置token
     * @param state
     * @param value
     */
    setToken(state, value) {
        state.token = value;
    },
    /**
     * 设置支付token
     * @param state
     * @param value
     */
    setPayToken(state, value) {
        state.payToken = value;
    },
    setMerchantPubId(state, value) {
        state.merchantPubId = value;
    },
    /**
     * 设置isOpenCredit
     * @param state
     * @param value
     */
    setIsOpenCredit(state, value) {
        state.isOpenCredit = value;
    },
    /**
     * 设置name
     * @param state
     * @param value
     */
    setName(state, value) {
        state.name = value;
    },
    /**
     * 用户信息
     */
    setUserInfo(state, value) {
        state.userInfo = value;
    },
    /**
     * 钱包信息
     */
    setWalletInfo(state, value) {
        state.walletInfo = value;
    },
    /**
     * 设置avatar
     * @param state
     * @param value
     */
    setAvatar(state, value) {
        state.avatar = value;
    },
    /**
     * 设置franchisee
     * @param state
     * @param value
     */
    setFranchisee(state, value) {
        state.franchisee = value;
    }
};

// 用户模块actions
const actions = {
    /**
     * 用户登录
     * @param context
     * @param value
     */
    login({ commit, dispatch }, { tempToken }) {
        return api.redirectService
            .swapToken(tempToken)
            .then(res => {
                commit('setToken', res.data.accessToken);
            })
            .then(res => {
                commit('setName', res.data.realName);
                return api.accountService.queryFranchiseeInfo();
            })
            .then(res => {
                let franchisee = {
                    userId: res.userId,
                    orgId: res.orgId,
                    accountId: res.accountId
                };
                commit('setFranchisee', franchisee);
            });
    },
    wallet({ commit, dispatch }) {
        return api.walletServiceNew.getEnterpriseWallet().then(res => {
            commit('setWalletInfo', res.data.data);
        });
    },
    /**
     * 用户登出
     * @param context
     */
    logout({ commit }) {
        // 清空用户信息
        commit('setToken', '');
        commit('setPayToken', '');
        commit('setName', '');
        commit('setAvatar', '');
        commit('setWalletInfo', null);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
